import { Collection, } from "@bluelibs/x-ui";
import { InboxTag } from "@root/api.types";
export class InboxTagsCollection extends Collection {
    getName() {
        return "InboxTags";
    }
    getInputs() {
        return {
            insert: "InboxTagInsertInput!",
            update: "InboxTagUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
